import { createSelector } from 'reselect';

import { THEME_ID_DEFAULT } from 'yeself-common/defaults/ApplicationDefaults';

import { getApplicationDetail } from 'Console/data/applicationDetail/settings/SettingsSelector';

import { APPLICATION_DETAIL_THEMES_DEFAULT_STATE } from 'Console/constants/applicationDetailDefaults';

export const THEME_NAME_DEFAULT = '(Not Set)';

export const selectThemes = createSelector(
    [getApplicationDetail],
    ({ themes } = APPLICATION_DETAIL_THEMES_DEFAULT_STATE) => themes
);

export const selectThemesDetails = createSelector([selectThemes], ({ theme }) => theme);

export const selectThemesDetailsData = createSelector([selectThemesDetails], ({ data = [] }) => data);

export const selectThemesIds = createSelector([selectThemes], ({ themeIds }) => themeIds);

export const selectThemeIdsData = createSelector([selectThemesIds], ({ data = [] }) => data);

export const selectAllowedThemesWithNotSetValue = createSelector([selectThemesIds], ({ data = [] }) => [
    { id: THEME_ID_DEFAULT, name: THEME_NAME_DEFAULT },
    ...data,
]);

export const selectThemeSchemas = createSelector([selectThemes], ({ themeSchemas }) => themeSchemas);

export const selectThemeSchemasData = createSelector([selectThemeSchemas], ({ data }) => data);

export const selectThemeSchemasIsLoading = createSelector(
    [selectThemeSchemas],
    ({ isLoading }) => isLoading
);
